import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import NavLangStackEditor from './NavLangStackEditor';
import {
  linkTemplate, updateAt, removeAt, missingLangs,
} from './navEditorState';

// One sortable list of {text, url, visible} links. Used by every column and by
// the secondary-links list; all instances share type LINK so rows can be
// dragged between any two lists (including column -> secondary).
const NavLinksArea = ({
  droppableId, links, onChange, addLabel,
}) => {
  const [editing, setEditing] = useState(null);

  return (
    <div className="mnv-links">
      <Droppable droppableId={droppableId} type="LINK">
        {provided => (
          <div ref={provided.innerRef} {...provided.droppableProps} className="mnv-links-drop">
            {links.map((link, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Fragment key={index}>
                <Draggable draggableId={`${droppableId}--${index}`} index={index}>
                  {p => (
                    <div
                      ref={p.innerRef}
                      {...p.draggableProps}
                      className={`mnv-linkrow${link.visible === false ? ' mnv-dim' : ''}`}
                    >
                      <span className="mnv-grip" {...p.dragHandleProps}>⋮⋮</span>
                      <button
                        type="button"
                        className="mnv-linktext"
                        title="Edit link (all languages)"
                        onClick={() => setEditing(editing === index ? null : index)}
                      >
                        <span className="mnv-t">
                          {(link.text && link.text.en) || '(empty)'}
                          {missingLangs(link.text).length > 0 && <i className="mnv-dot" title="missing translations" />}
                        </span>
                        <span className="mnv-u">{link.url || 'no url'}</span>
                      </button>
                    </div>
                  )}
                </Draggable>
                {editing === index && (
                  <NavLangStackEditor
                    label="Link"
                    text={link.text}
                    onChangeText={text => onChange(updateAt(links, index, { ...link, text }))}
                    url={link.url}
                    onChangeUrl={u => onChange(updateAt(links, index, { ...link, url: u }))}
                    urlPlaceholder="/barcelona/tickets or https://…"
                    visible={link.visible}
                    onToggleVisible={() => onChange(updateAt(links, index, { ...link, visible: link.visible === false }))}
                    onDelete={() => { setEditing(null); onChange(removeAt(links, index)); }}
                    onDone={() => setEditing(null)}
                  />
                )}
              </Fragment>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      <button
        type="button"
        className="mnv-add"
        onClick={() => { onChange([...links, linkTemplate()]); setEditing(links.length); }}
      >
        {`+ ${addLabel}`}
      </button>
    </div>
  );
};

NavLinksArea.propTypes = {
  droppableId: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onChange: PropTypes.func.isRequired,
  addLabel: PropTypes.string.isRequired,
};

export default NavLinksArea;
